module.exports = __webpack_public_path__ + "static/img/h_44@2x.8d1f7122.png";